import { Action } from 'redux';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import { IApplication } from '../types/application';

export const APPLICATIONS_FETCH_REQUEST = 'APPLICATIONS_FETCH_REQUEST';
export const APPLICATIONS_FETCH_SUCCESS = 'APPLICATIONS_FETCH_SUCCESS';
export const APPLICATIONS_FETCH_ERROR = 'APPLICATIONS_FETCH_ERROR';

export interface IApplicationsFetchRequestAction extends Action {
  type: typeof APPLICATIONS_FETCH_REQUEST;
  payload: IPaginationParams;
}

export interface IApplicationsFetchSuccessAction extends Action {
  type: typeof APPLICATIONS_FETCH_SUCCESS;
  payload: { applications: IApplication[]; meta: IPaginationMetaResponse };
}

export interface IApplicationsFetchErrorAction extends Action {
  type: typeof APPLICATIONS_FETCH_ERROR;
  message: string;
}

export type IApplicationsFetchAction =
  | IApplicationsFetchSuccessAction
  | IApplicationsFetchErrorAction;

export function fetchApplicationsRequest(
  params?: IPaginationParams
): IApplicationsFetchRequestAction {
  return {
    type: APPLICATIONS_FETCH_REQUEST,
    payload: {
      ...params,
    },
  };
}

export function fetchApplicationsSuccess(
  applications: IApplication[],
  meta: IPaginationMetaResponse
): IApplicationsFetchSuccessAction {
  return {
    type: APPLICATIONS_FETCH_SUCCESS,
    payload: {
      applications,
      meta,
    },
  };
}

export function fetchApplicationsError(message: string): IApplicationsFetchErrorAction {
  return {
    type: APPLICATIONS_FETCH_ERROR,
    message,
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/applications.ts